import { render, staticRenderFns } from "./AuthShell.vue?vue&type=template&id=44698313&"
import script from "./AuthShell.vue?vue&type=script&lang=js&"
export * from "./AuthShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports